import type { ReactNode } from 'react';

import { EmptyState, Icon, formatValue } from './FdPrimitives.tsx';

type Column<T extends object> = {
  key: string;
  header: string;
  className?: string;
  headerClassName?: string;
  render?: (row: T) => ReactNode;
};

export function DataTable<T extends object>({
  rows,
  columns,
  title,
  icon,
  emptyTitle = 'No records found',
  emptyMessage = 'This table will populate when data is available.',
}: {
  rows: T[];
  columns: Column<T>[];
  title?: string;
  icon?: string;
  emptyTitle?: string;
  emptyMessage?: string;
}) {
  if (rows.length === 0) {
    return <EmptyState icon="search_off" title={emptyTitle} message={emptyMessage} />;
  }

  return (
    <div className="card data-card">
      {title && (
        <div className="ch">
          {icon && <Icon name={icon} />}
          <b>{title}</b>
          <span className="r">{rows.length.toLocaleString()} rows</span>
        </div>
      )}
      <div className="table-scroll">
        <table className="tbl">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.key} className={column.headerClassName}>
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                {columns.map((column) => (
                  <td key={column.key} className={column.className}>
                    {column.render ? column.render(row) : formatValue((row as Record<string, unknown>)[column.key])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
